var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_container"},[_c('div',{staticClass:"btn btn_d",on:{"click":_vm.downloadImages}},[_vm._v("Download "+_vm._s(_vm.selectedImages.length)+" images")])])}
var staticRenderFns = []

export { render, staticRenderFns }